import type { IconSvgObject } from './types';

const AiScanIcon: IconSvgObject = [
  ["path", { d: "M21.5 7.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H16.5M21.5 16.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H16.5M2.5 16.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H7.5M2.5 7.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 8.5V6.5M10 11.5V12M14 11.5V12M9 16.5H15C16.1046 16.5 17 15.6046 17 14.5V10.5C17 9.39543 16.1046 8.5 15 8.5H9C7.89543 8.5 7 9.39543 7 10.5V14.5C7 15.6046 7.89543 16.5 9 16.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AiScanIcon;
